import React, { useState, createElement } from 'react';
import { ChevronDown, ChevronUp, ChevronRight } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom'; // Import de useLocation

const SidebarItem = ({ icon: Icon, text, collapsed, subItems, to, badgeCount = 0, isOpen, onToggle }) => {
  const location = useLocation(); // Récupère l'URL actuelle
  const [localOpen, setLocalOpen] = useState(false);

  const hasSub = subItems && subItems.length > 0;
  // Contrôlé par le parent (accordéon) si onToggle est fourni, sinon local.
  const controlled = typeof onToggle === 'function';
  const open = controlled ? !!isOpen : localOpen;

  // Vérifie si l'élément ou l'un de ses sous-items est actif
  const isActive = location.pathname.startsWith(to) || (subItems && subItems.some(subItem => location.pathname.startsWith(subItem.to)));

  const handleClick = (e) => {
    if (hasSub) {
      if (!to || to === '#') e.preventDefault(); // dropdown pur : pas de navigation
      controlled ? onToggle() : setLocalOpen((v) => !v);
    }
  };

  return (
    <div>
      <Link
        to={to || '#'}
        onClick={handleClick}
        className={`flex items-center px-2 py-2 text-sm font-medium ${
          isActive
            ? 'text-white bg-primary'
            : 'text-gray-700 my-over hover:text-white active:bg-tertiary-200'
        } rounded-md ${collapsed ? 'justify-center' : ''}`}
      >
        {createElement(Icon, { className: 'w-5 h-5 flex-shrink-0' })}
        {!collapsed && (
          <>
            <span className="ml-3 flex-1">{text}</span>
            {badgeCount > 0 && (
              <span className="ml-2 inline-flex items-center justify-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800 min-w-[1.25rem]">
                {badgeCount > 99 ? '99+' : badgeCount}
              </span>
            )}
            {hasSub && (
              <span className="ml-auto">
                {open ? (
                  <ChevronUp className="w-4 h-4" />
                ) : (
                  <ChevronDown className="w-4 h-4" />
                )}
              </span>
            )}
          </>
        )}
      </Link>

      {/* Sous-items */}
      {!collapsed && open && hasSub && (
        <div className="pl-6 mt-1 space-y-1">
          {subItems.map((subItem, index) => {
            const isSubItemActive = location.pathname === subItem.to; // Vérifie si le sous-item est actif
            return (
              <Link
                key={index}
                to={subItem.to || '#'}
                className={`flex items-center px-2 py-2 text-sm font-medium rounded-md ${
                  isSubItemActive
                    ? 'text-primary'
                    : 'text-gray-700 hover:text-primary'
                }`}
              >
                <ChevronRight className="w-4 h-4 flex-shrink-0 opacity-70" />
                <span className="ml-2">{subItem.text}</span>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SidebarItem;